import { Button, Text } from '@fluentui/react-components';
import type { RepeatingPanelAction } from '@moko/utils';
import { repeatingPanelIcons } from './constants';

interface RepeatingPanelToolbarProps {
  onAction: (action: RepeatingPanelAction) => void;
  currentIndex: number;
  total: number;
  readOnly?: boolean;
}

export const RepeatingPanelToolbar = ({
  onAction,
  currentIndex,
  total,
  readOnly,
}: RepeatingPanelToolbarProps) => {
  const safeTotal = Math.max(total, 0);
  const safeIndex = safeTotal > 0 ? Math.min(currentIndex, safeTotal - 1) : 0;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
      <Button
        size="small"
        appearance="subtle"
        icon={repeatingPanelIcons.first}
        onClick={() => onAction('first')}
      />
      <Button
        size="small"
        appearance="subtle"
        icon={repeatingPanelIcons.prev}
        onClick={() => onAction('prev')}
      />
      <Text
        size={200}
        weight="semibold"
        style={{ minWidth: 36, textAlign: 'center' }}
      >
        {safeTotal > 0 ? `${safeIndex + 1}/${safeTotal}` : '0/0'}
      </Text>
      <Button
        size="small"
        appearance="subtle"
        icon={repeatingPanelIcons.next}
        onClick={() => onAction('next')}
      />
      <Button
        size="small"
        appearance="subtle"
        icon={repeatingPanelIcons.last}
        onClick={() => onAction('last')}
      />
      {!readOnly && (
        <>
          <Button
            size="small"
            appearance="subtle"
            icon={repeatingPanelIcons.add}
            onClick={() => onAction('add')}
          />
          <Button
            size="small"
            appearance="subtle"
            icon={repeatingPanelIcons.remove}
            onClick={() => onAction('remove')}
          />
        </>
      )}
    </div>
  );
};
